export const equipmentTypes = {
  HONEYWELL_EQUIPMENT_TYPE: ['CONNECT +', 'CONNECT', 'PROCONNECT'],
  TWOGIG_EQUIPMENT_TYPE: ['SMARTPRO', 'SMARTPRO +'],
  QOLSYS_EQUIPMENT_TYPE: ['SMARTPRO ELITE +', 'SMARTPRO ELITE'],
  HELIX_EQUIPMENT_TYPE: ['CLARE CONNECT', 'CLARE CONNECT TOUCH'],
  GE_EQUIPMENT_TYPE: [],
};
